import { ParentSummary } from '@features/parent-page/components/ParentSummary'
import { useParentSuspense } from '@features/parent-page/queries'
import { Card, Group, Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/parents/$parentId/')({
    component: RouteComponent,
})

function RouteComponent() {

    const { parentId } = Route.useParams()

    const { data: parent } = useParentSuspense(parentId)

    return (
        <Stack>
            <ParentSummary parentId={parentId}/>
        </Stack>
    )
}
